
export enum WarrantyStatusCd {
	APPROVED = 'Approved',
	DENIED = 'Denied',
	FILED = 'Filed',
	NONE = 'None'}

